module.exports = __webpack_public_path__ + "static/media/styledmenu-close.a4299d12.svg";